/**
 * i18next namespace of the design system. Every user-facing string of packages/ui lives in
 * i18n/locales/{uz,ru,en}.json (CONVENTIONS code style 1, NFR-08: uz-Latn default, ru, en).
 * Apps register `uiLocaleResources` under the `ui` namespace of their i18next instance.
 */
import { useTranslation } from 'react-i18next';
import englishUiMessages from './locales/en.json';
import russianUiMessages from './locales/ru.json';
import uzbekUiMessages from './locales/uz.json';

export const UI_I18N_NAMESPACE = 'ui';

export const uiLocaleResources = {
  uz: uzbekUiMessages,
  ru: russianUiMessages,
  en: englishUiMessages,
} as const;

export function useUiTranslation() {
  return useTranslation(UI_I18N_NAMESPACE);
}

/** Maps the active i18next language ("uz", "uz-Latn", "ru-RU", ...) to a formatting language. */
export function toUiLanguage(languageCode: string | undefined): 'uz' | 'ru' | 'en' {
  if (languageCode?.startsWith('ru') === true) {
    return 'ru';
  }
  if (languageCode?.startsWith('en') === true) {
    return 'en';
  }
  return 'uz';
}

export function useFormatLanguage(): 'uz' | 'ru' | 'en' {
  const { i18n } = useUiTranslation();
  return toUiLanguage(i18n.language);
}
